// extracted by mini-css-extract-plugin
export var btnMargin = "StepItem-module--btnMargin--26c46";
export var contactStepTitle = "StepItem-module--contactStepTitle--9d4d0";
export var pageReadMore = "StepItem-module--pageReadMore--c43f8";
export var readMore = "StepItem-module--readMore--1ee2a";
export var readMoreHome = "StepItem-module--readMoreHome--af887";
export var separatorLine = "StepItem-module--separatorLine--3a027";
export var spanNumber = "StepItem-module--spanNumber--9b885";
export var stepContent = "StepItem-module--stepContent--07f31";
export var stepContentContainer = "StepItem-module--stepContentContainer--db97f";
export var stepTitle = "StepItem-module--stepTitle--7b535";
export var stepsCard = "StepItem-module--stepsCard--a4851";
export var stepsHeader = "StepItem-module--stepsHeader--2ebcd";
export var stepsOpened = "StepItem-module--stepsOpened--d353e";